import React, { useRef, useState, useEffect } from "react";
import "./UOD.css";
import DropDown from "../CreateBatch/DropdownCB";
import { API_BASE_URL } from "../../Config/Config";
import CustomModal from "./studentModal";
import axios from "axios";
import FolderUpload from "./FolderUpload";
import WarningImage from "./../../Assets/Images/CommanImages/Warning.png";
import SuccessMessage from "./SucessComponent";
import Colors from "../../Constants/Colors";
import searchyellow from "../../Assets/Images/CommanImages/searchyellow.png";
import InputComponent from "../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
import { useNavigate } from "react-router-dom";
import SucessImg from "../../Assets/Images/CommanImages/success.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import IntrogativeImg from "../../Assets/Images/CommanImages/Informative.png";
const UploadOmrV2 = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
}) => {
  const [courses, setCourses] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [testNames, setTestNames] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [testSchedules, setTestSchedules] = useState([]); // Changed from testNames

  const [showDropdown, setShowDropdown] = useState(false);
  const fileInput = useRef(null);
  const [showAnimation, setShowAnimation] = useState(false);
  const [assessment_id, Selected_assessment_id] = useState("");
  const [studentsToSkip, setStudentsToSkip] = useState([]);
  const [studentsToOverride, setStudentsToOverride] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [students, setStudents] = useState([]);
  const [file, setFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState([]);
  const [apiFileNames, setApiFileNames] = useState([]);
  const [uploadedFileNames, setUploadedFileNames] = useState([]);
  const [files, setFiles] = useState([]);
  const [preSignedUrls, setPreSignedUrls] = useState([]);
  const [urlList, setUrlList] = useState([]);
  const [excelUploaded, setExcelUploaded] = useState(false);
  const [matchedFiles, setMatchedFiles] = useState([]);
  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const user_name = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientBranchId =
    dataClient?.client_schema_name[6][0].client_branch_id || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

  const navigate = useNavigate();

  const [showModalSider, setShowModalSider] = useState(false);
  const [animationSider, setAnimationSider] = useState("");

  const openModalSider = () => {
    setAnimationSider("active");
    setShowModalSider(true);
  };

  const closeModalSider = () => {
    setAnimationSider(""); // reset animation
    setTimeout(() => setShowModalSider(false), 500); // delay setting showModal to false
  };

  useEffect(() => {
    if (!showModalSider && animationSider !== "active") {
      setAnimationSider("closing");
    }
  }, [showModalSider]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
        );

        const data = await response.json();

        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchAssessmentNames = async () => {
      if (courseOpted && searchKey) {
        try {
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-assessment-names/?assessment_type_id=2&course_id=${courseOpted}&client_branch_id=${clientId}&search_key=${searchKey}`
          );
          const data = await response.json();
          if (data.status === 200) {
            setTestNames(data.data);

            setShowDropdown(true);
          }
        } catch (error) {
          console.error("Error fetching assessment names:", error);
        }
      } else {
        setShowDropdown(false);
      }
    };
    fetchAssessmentNames();
  }, [courseOpted, searchKey]);

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);
  };
  const handleTestSelect = (testSchedule) => {
    setSelectedTest({
      ...testSchedule,
      assessment_id: testSchedule.test_schedule_id,
      assessment_name: testSchedule.test_name,
    });
    // Set search key to show "Test Name / Status"
    const displayText = `${testSchedule.test_name} / ${testSchedule.status_name}`;
    setSearchKey(displayText);
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleDivClick = () => {
  //   if (!courseOpted || !selectedTest) {

  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             "Please select a course and test before uploading a file."
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(IntrogativeImg);
  //   } else {
  //     // Reset the file input value
  //     fileInput.current.value = null;
  //     fileInput.current.click();
  //     // Only start the animation if a file is selected
  //     if (fileInput.current.files.length > 0) {
  //       setShowAnimation(true);
  //     }
  //   }
  // };

  const handleDivClick = () => {
    if (!courseOpted || !selectedTest) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              "Please select a course and test before uploading a file."
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(IntrogativeImg);
    } else {
      // Show loading message
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Loading...</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(null); // or use a loading image if you have one

      // Reset and trigger file input in the background
      fileInput.current.value = null;
      fileInput.current.click();
    }
  };

  // const handleFileChange = async (event) => {
  //   const selectedFile = event.target.files[0];
  //   const data = new FormData();
  //   data.append("excel_file", selectedFile, selectedFile.name);
  //   setFile(selectedFile);

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/process-omr-excel-v2/?test_schedule_id=${selectedTest.assessment_id}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           accept: "application/json",
  //         },
  //         body: data,
  //       }
  //     );

  //     const responseData = await response.json();

  //     if (responseData.status === 404) {
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>{responseData.message}</span>
  //             <div style={{ marginTop: "15px" }}>
  //               <button
  //                 onClick={() => {
  //                   setMessageBox(null);
  //                   setActiveImg(null);
  //                 }}
  //                 className="Excel-UOD-button-3"
  //               >
  //                 OK
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(WarningImage);
  //       return;
  //     }

  //     if (!response.ok) {
  //       if (response.status === 500) {
  //         setMessageBox(
  //           <div className="Container-messageBOX">
  //             <div className="messagebox-insider1">
  //               <div className="loader-tc"></div>
  //               <span>
  //                 The server encountered an error processing the file. Please
  //                 ensure the file format is supported.
  //               </span>
  //               <div style={{ marginTop: "15px" }}>
  //                 <button
  //                   onClick={() => {
  //                     setMessageBox(null);
  //                     setActiveImg(null);
  //                     window.location.reload();
  //                   }}
  //                 >
  //                   OK
  //                 </button>
  //               </div>
  //             </div>
  //           </div>
  //         );
  //         setActiveImg(WarningImage);
  //         return;
  //       }
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const apiFileNames = responseData.url_list.map((item) =>
  //       item.file_path.split("\\").pop()
  //     );
  //     const preSignedUrls = responseData.url_list.map((item) => ({
  //       fileName: item.file_path.split("\\").pop(),
  //       url: item.url,
  //     }));

  //     setApiFileNames(apiFileNames);
  //     setPreSignedUrls(preSignedUrls);
  //     setUrlList(responseData.url_list);
  //     setShowAnimation(false);

  //     // In UploadOmrV2.jsx
  //     if (responseData.errors && responseData.errors.length > 0) {
  //       setErrors(responseData.errors);
  //       pauseTimer(); // Pause the auto-close timer
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <div style={{ display: "flex", gap: "10px", marginLeft: "8px" }}>
  //               <div>
  //                 Do you want to resolve the missing information or continue?
  //                 Please see the bottom of the page for the missing information
  //                 in the Excel file.
  //               </div>

  //               <div style={{ display: "flex", gap: "10px" }}>
  //                 <button
  //                   onClick={() => {
  //                     setMessageBox(null);
  //                     setActiveImg(null);
  //                     setIsMessageBoxVisible(false); // Add this line
  //                     setStudents(responseData.data);
  //                     if (responseData.data && responseData.data.length > 0) {
  //                       setIsModalOpen(true);
  //                     }
  //                   }}
  //                   className="testreportcard-create-btn width-superseeding-2"
  //                 >
  //                   Continue
  //                 </button>
  //                 <button
  //                   onClick={() => {
  //                     setMessageBox(null);
  //                     setActiveImg(null);
  //                     setIsMessageBoxVisible(false); // Add this line
  //                   }}
  //                   className="testreportcard-create-btn width-superseeding-2"
  //                 >
  //                   Fix Errors
  //                 </button>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(WarningImage);
  //       setIsMessageBoxVisible(true);
  //     } else {
  //       setErrors([]);
  //       setStudents(responseData.data);
  //       if (responseData.data && responseData.data.length > 0) {
  //         setIsModalOpen(true);
  //       }
  //     }
  //   } catch (error) {
  //     setShowAnimation(false);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             An error occurred while trying to serve your request. Please check
  //             your network connection and the input file for error and try
  //             again.
  //           </span>
  //           <div style={{ marginTop: "15px", textAlign: "center" }}>
  //             <button
  //               onClick={() => {
  //                 setMessageBox(null);
  //                 setActiveImg(null);
  //               }}
  //             >
  //               OK
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(WarningImage);
  //     console.error(error);
  //   }

  //   // Reset the value of the file input field
  //   event.target.value = null;
  // };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    const data = new FormData();
    data.append("excel_file", selectedFile, selectedFile.name);
    setFile(selectedFile);

    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/process-omr-excel-v2/?test_schedule_id=${selectedTest.assessment_id}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
          },
          body: data,
        }
      );

      const responseData = await response.json();

      if (responseData.status === 404) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{responseData.message}</span>
              <div style={{ marginTop: "15px" }}>
                <button
                  onClick={() => {
                    setMessageBox(null);
                    setActiveImg(null);
                  }}
                  className="Excel-UOD-button-3"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        );
        setActiveImg(WarningImage);
        return;
      }

      if (!response.ok) {
        if (response.status === 500) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  The server encountered an error processing the file. Please
                  ensure the file format is supported.
                </span>
                <div style={{ marginTop: "15px" }}>
                  <button
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      window.location.reload();
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          );
          setActiveImg(WarningImage);
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiFileNames = responseData.url_list.map((item) =>
        item.file_path.split("\\").pop()
      );
      const preSignedUrls = responseData.url_list.map((item) => ({
        fileName: item.file_path.split("\\").pop(),
        url: item.url,
      }));

      setApiFileNames(apiFileNames);
      setPreSignedUrls(preSignedUrls);
      setUrlList(responseData.url_list);
      setShowAnimation(false);

      // Handle status 200 - No errors (ONE MESSAGE BOX ONLY)
      if (responseData.status === 200) {
        setErrors([]);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider2">
              <div className="loader-tc"></div>
              <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
                <div className="col-cs-uni">
                  <span>There are no errors. Please now browse the image folder.</span>
                </div>
                <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                  <button
                    style={{ marginRight: "8px" }}
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                    }}
                    className="testreportcard-create-btn"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
        setActiveImg(SucessImg);
        setIsMessageBoxVisible(true);
        setStudents(responseData.data);
        if (responseData.data && responseData.data.length > 0) {
          setIsModalOpen(true);
        }
      }

      // Handle status 207 - Some errors (ONE MESSAGE BOX ONLY)
      else if (responseData.status === 207) {
        setErrors(responseData.errors || []);
        pauseTimer();
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider2">
              <div className="loader-tc"></div>
              <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
                <div className="col-cs-uni-7">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>There are some errors. You can resolve or continue to browse image folder.</span>
                    {responseData.errors && responseData.errors.length > 0 && (
                      <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                        Please see the bottom of the page for error details.
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                  <button
                    style={{ marginRight: "8px" }}
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                      setStudents(responseData.data);
                      if (responseData.data && responseData.data.length > 0) {
                        setIsModalOpen(true);
                      }
                    }}
                    className="testreportcard-create-btn width-superseeding-2"
                  >
                    Continue
                  </button>
                  <button
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                    }}
                    className="testreportcard-create-btn width-superseeding-2"
                  >
                    Fix Errors
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
        setActiveImg(WarningImage);
        setIsMessageBoxVisible(true);
      }

      // Handle status 500 - Server errors (ONE MESSAGE BOX ONLY)
      else if (responseData.status === 500) {
        setErrors(responseData.errors || []);
        pauseTimer();
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider2">
              <div className="loader-tc"></div>
              <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
                <div className="col-cs-uni-7">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>There are some errors. You can resolve or continue with image folder.</span>
                    {responseData.errors && responseData.errors.length > 0 && (
                      <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                        Please see the bottom of the page for error details.
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                  <button
                    style={{ marginRight: "8px" }}
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                      setStudents(responseData.data);
                      if (responseData.data && responseData.data.length > 0) {
                        setIsModalOpen(true);
                      }
                    }}
                    className="testreportcard-create-btn width-superseeding-2"
                  >
                    Continue
                  </button>
                  <button
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                    }}
                    className="testreportcard-create-btn width-superseeding-2"
                  >
                    Fix Errors
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }

    } catch (error) {
      setShowAnimation(false);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              An error occurred while trying to serve your request. Please check
              your network connection and the input file for error and try
              again.
            </span>
            <div style={{ marginTop: "15px", textAlign: "center" }}>
              <button
                onClick={() => {
                  setMessageBox(null);
                  setActiveImg(null);
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      );
      setActiveImg(WarningImage);
      console.error(error);
    }

    // Reset the value of the file input field
    event.target.value = null;
  };


  // Add this tester function in your component
  // const testMessageBoxes = (statusCode) => {
  //   // Mock response data
  //   const mockResponseData = {
  //     status: statusCode,
  //     data: [
  //       { roll_no: "001", student_name: "Test Student 1" },
  //       { roll_no: "002", student_name: "Test Student 2" }
  //     ],
  //     errors: statusCode !== 200 ? ["Error 1: Test error", "Error 2: Another test error"] : [],
  //     url_list: [
  //       { file_path: "test\\image1.jpg", url: "https://example.com/presigned1" },
  //       { file_path: "test\\image2.jpg", url: "https://example.com/presigned2" }
  //     ]
  //   };

  //   // Test Status 200 - No errors
  //   if (statusCode === 200) {
  //     setErrors([]);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider2">
  //           <div className="loader-tc"></div>
  //           <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
  //             <div className="col-cs-uni">
  //               <span>There are no errors. Please now browse the image folder.</span>
  //             </div>
  //             <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
  //               <button
  //                 style={{ marginRight: "8px" }}
  //                 onClick={() => {
  //                   setMessageBox(null);
  //                   setActiveImg(null);
  //                   setIsMessageBoxVisible(false);
  //                 }}
  //                 className="testreportcard-create-btn"
  //               >
  //                 OK
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //     );
  //     setActiveImg(SucessImg);
  //     setIsMessageBoxVisible(true);
  //   }

  //   // Test Status 207 - Some errors
  //   else if (statusCode === 207) {
  //     setErrors(mockResponseData.errors);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider2">
  //           <div className="loader-tc"></div>
  //           <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
  //             <div className="col-cs-uni-7">
  //               <div style={{ display: "flex", flexDirection: "column" }}>
  //                 <span>There are some errors. You can resolve or continue with image folder.</span>
  //                 <span style={{ fontSize: "12px", fontStyle: "italic" }}>
  //                   Please see the bottom of the page for error details.
  //                 </span>
  //               </div>
  //             </div>
  //             <div className="col-cs-uni">
  //               <button
  //                 style={{ marginRight: "8px" }}
  //                 onClick={() => {
  //                   setMessageBox(null);
  //                   setActiveImg(null);
  //                   setIsMessageBoxVisible(false);
  //                   setStudents(mockResponseData.data);
  //                   setIsModalOpen(true);
  //                 }}
  //                 className="testreportcard-create-btn width-superseeding-2"
  //               >
  //                 Continue
  //               </button>
  //               <button
  //                 onClick={() => {
  //                   setMessageBox(null);
  //                   setActiveImg(null);
  //                   setIsMessageBoxVisible(false);
  //                 }}
  //                 className="testreportcard-create-btn width-superseeding-2"
  //               >
  //                 Fix Errors
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(WarningImage);
  //     setIsMessageBoxVisible(true);
  //   }

  //   // Test Status 500 - Server errors
  //   else if (statusCode === 500) {
  //     setErrors(mockResponseData.errors);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider2">
  //           <div className="loader-tc"></div>
  //           <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
  //             <div className="col-cs-uni-7">
  //               <div style={{ display: "flex", flexDirection: "column" }}>
  //                 <span>There are some errors. You can resolve or continue with image folder.</span>
  //                 <span style={{ fontSize: "12px", fontStyle: "italic" }}>
  //                   Please see the bottom of the page for error details.
  //                 </span>
  //               </div>
  //             </div>
  //             <div className="col-cs-uni">
  //               <button
  //                 style={{ marginRight: "8px" }}
  //                 onClick={() => {
  //                   setMessageBox(null);
  //                   setActiveImg(null);
  //                   setIsMessageBoxVisible(false);
  //                   setStudents(mockResponseData.data);
  //                   setIsModalOpen(true);
  //                 }}
  //                 className="testreportcard-create-btn width-superseeding-2"
  //               >
  //                 Continue
  //               </button>
  //               <button
  //                 onClick={() => {
  //                   setMessageBox(null);
  //                   setActiveImg(null);
  //                   setIsMessageBoxVisible(false);
  //                 }}
  //                 className="testreportcard-create-btn width-superseeding-2"
  //               >
  //                 Fix Errors
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorImg);
  //     setIsMessageBoxVisible(true);
  //   }
  // };

  // Add test buttons in your JSX (temporarily for testing)


  const handleOMRUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("excel_file", file, file.name);

      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/upload-omr-excel-v2?test_schedule_id=${selectedTest.assessment_id
          }&username=${user_name}&skip_rows=${studentsToSkip.join(",")}`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
            },
            body: formData,
          }
        );
        const data = await response.json();
        console.log("OMR Upload Response:", data);

        // Check for direct status 404 first (this is your case)
        if (data.status === 404) {
          // Format errors for display
          const formattedErrors = Array.isArray(data.data)
            ? data.data.map((errorItem) =>
              Array.isArray(errorItem) ? errorItem[0] : errorItem
            )
            : [data.message];

          setErrors(formattedErrors);

          // Show enhanced 404 message box
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <div>
                  Upload Failed : {data.message}
                  {/* <div >
                    <strong>Issues found:</strong> {formattedErrors.length}{" "}
                    error(s)
                    <br />
                    <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                      See detailed errors at the bottom of the page.
                    </span>
                  </div> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <button
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                    }}
                    style={{
                      backgroundColor: "#318682",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Fix and Retry
                  </button>
                  <button
                    onClick={() => {
                      const element = document.createElement("a");
                      const file = new Blob([formattedErrors.join("\n")], {
                        type: "text/plain",
                      });
                      element.href = URL.createObjectURL(file);
                      element.download = "upload_errors.txt";
                      document.body.appendChild(element);
                      element.click();
                      document.body.removeChild(element);
                    }}
                    style={{
                      backgroundColor: "#6c757d",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Download Errors
                  </button>
                </div>
              </div>
            </div>
          );
          setActiveImg(WarningImage);
          setIsMessageBoxVisible(true);
          return { message: { status: 404 }, data: formattedErrors };
        }

        // Check for nested message status (for other cases)
        if (data.message && data.message.status === 207) {
          setErrors(data.message.data);
          setShowModal(true);
          return data;
        }

        if (data.message && data.message.status === 200) {
          setErrors(data.message.data);
          setShowModal(true);
          return data;
        }

        if (data.message && data.message.status === 500) {
          setErrors(data.message.data);
          setShowModal(true);
          return data;
        }

        // Default return
        return data;
      } catch (error) {
        console.error("Error in handleOMRUpload:", error);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Network error occurred while uploading. Please check your
                connection and try again.
              </span>
              <div style={{ marginTop: "15px", textAlign: "center" }}>
                <button
                  onClick={() => {
                    setMessageBox(null);
                    setActiveImg(null);
                    setIsMessageBoxVisible(false);
                  }}
                  style={{
                    backgroundColor: "#318682",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        );
        setActiveImg(WarningImage);
        setIsMessageBoxVisible(true);
        throw error;
      }
    }
  };

  const handleSave = async () => {
    // Show loading message
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Please wait processing data...</span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
    setActiveImg(null);

    try {
      const omrUploadResponse = await handleOMRUpload();

      console.log("OMR Upload Response:", omrUploadResponse); // Debug log

      if (omrUploadResponse && omrUploadResponse.url_list) {
        const apiFileNames = omrUploadResponse.url_list.map((item) =>
          item.file_path.split("\\").pop()
        );
        const preSignedUrls = omrUploadResponse.url_list.map((item) => ({
          fileName: item.file_path.split("\\").pop(),
          url: item.url,
        }));
        setApiFileNames(apiFileNames);
        setPreSignedUrls(preSignedUrls);
      }

      // Check for nested message structure first (from handleOMRUpload)
      const responseStatus = omrUploadResponse.message?.status || omrUploadResponse.status;
      const responseMessage = omrUploadResponse.message?.message || omrUploadResponse.message;
      const responseData = omrUploadResponse.message?.data || omrUploadResponse.data;

      // Handle Status 200 - Success
      if (responseStatus === 200) {
        setErrors([]);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider2">
              <div className="loader-tc"></div>
              <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
                <div className="col-cs-uni">
                  <span>{responseMessage || "OMR data uploaded successfully!"}</span>
                </div>
                <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                  <button
                    style={{ marginRight: "8px" }}
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                      window.location.reload();
                    }}
                    className="testreportcard-create-btn"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
        setActiveImg(SucessImg);
        setIsMessageBoxVisible(true);
        closeModalSider();
      }

      // Handle Status 207 - Partial Success with Errors
      else if (responseStatus === 207) {
        // Format errors - handle nested arrays
        const formattedErrors = Array.isArray(responseData)
          ? responseData.map(errorItem => Array.isArray(errorItem) ? errorItem[0] : errorItem)
          : [];

        setErrors(formattedErrors);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider2">
              <div className="loader-tc"></div>
              <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
                <div className="col-cs-uni">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{responseMessage || "Students response to tests uploaded with errors."}</span>
                    {formattedErrors.length > 0 && (
                      <span style={{ fontSize: "12px", fontStyle: "italic", marginTop: "5px" }}>
                        {formattedErrors.length} error(s) found. See details at the bottom of the page.
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                  <button
                    style={{ marginRight: "8px" }}
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                      setShowModal(true);
                    }}
                    className="testreportcard-create-btn"
                  >
                    View Details
                  </button>
                  <button
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                      window.location.reload();
                    }}
                    className="testreportcard-create-btn"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
        setActiveImg(WarningImage);
        setIsMessageBoxVisible(true);
        closeModalSider();
      }

      // Handle Status 500 - Server Error
      else if (responseStatus === 500) {
        // Format errors - handle nested arrays
        const formattedErrors = Array.isArray(responseData)
          ? responseData.map(errorItem => Array.isArray(errorItem) ? errorItem[0] : errorItem)
          : [];

        setErrors(formattedErrors);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider2">
              <div className="loader-tc"></div>
              <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
                <div className="col-cs-uni">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{responseMessage || "Server error occurred while uploading OMR data."}</span>
                    {formattedErrors.length > 0 && (
                      <span style={{ fontSize: "12px", fontStyle: "italic", marginTop: "5px" }}>
                        {formattedErrors.length} error(s) found. See details at the bottom of the page.
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                  <button
                    style={{ marginRight: "8px" }}
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                      setShowModal(true);
                    }}
                    className="testreportcard-create-btn"
                  >
                    View Details
                  </button>
                  <button
                    onClick={() => {
                      setMessageBox(null);
                      setActiveImg(null);
                      setIsMessageBoxVisible(false);
                    }}
                    className="testreportcard-create-btn"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        closeModalSider();
      }

      // Fallback for unexpected responses
      else {
        console.warn("Unexpected response structure:", omrUploadResponse);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Upload completed. Please check the results.</span>
              <div style={{ marginTop: "15px", textAlign: "center" }}>
                <button
                  onClick={() => {
                    setMessageBox(null);
                    setActiveImg(null);
                    setIsMessageBoxVisible(false);
                    window.location.reload();
                  }}
                  className="Excel-UOD-button-3"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        );
        setActiveImg(SucessImg);
        setIsMessageBoxVisible(true);
        closeModalSider();
      }

    } catch (error) {
      console.error(error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error processing data. Please try again.</span>
            <div style={{ marginTop: "15px", textAlign: "center" }}>
              <button
                onClick={() => {
                  setMessageBox(null);
                  setActiveImg(null);
                  setIsMessageBoxVisible(false);
                }}
                className="Excel-UOD-button-3"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      closeModalSider();
    }
  };



  // const handleSave = async () => {
  //   // openModalSider();
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Please wait processing data...</span>
  //       </div>
  //     </div>
  //   );
  //   setIsMessageBoxVisible(true);
  //   setActiveImg(SucessImg);

  //   try {
  //     const omrUploadResponse = await handleOMRUpload();
  //     if (omrUploadResponse && omrUploadResponse.url_list) {
  //       const apiFileNames = omrUploadResponse.url_list.map((item) =>
  //         item.file_path.split("\\").pop()
  //       );
  //       const preSignedUrls = omrUploadResponse.url_list.map((item) => ({
  //         fileName: item.file_path.split("\\").pop(),
  //         url: item.url,
  //       }));
  //       setApiFileNames(apiFileNames);
  //       setPreSignedUrls(preSignedUrls);
  //     }
  //     // closeModalSider();

  //     if (omrUploadResponse.message.status === 200) {
  //       setSuccessMessageVisible(true);
  //       closeModalSider();
  //     }
  //     if (omrUploadResponse.message.status === 207) {
  //       setShowModal(true);
  //       closeModalSider();
  //     }
  //     if (omrUploadResponse.message.status === 500) {
  //       setShowModal(true);
  //       closeModalSider();
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Error processing data. Please try again.</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorImg);
  //   }
  // };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowAnimation(false);
    window.location.reload();
  };
  const handleSkipChange = (rollNo) => {
    setStudentsToSkip((prev) => {
      if (prev.includes(rollNo)) {
        return prev.filter((roll) => roll !== rollNo);
      } else {
        return [...prev, rollNo];
      }
    });
  };
  const handleOverrideChange = (rollNo) => {
    setStudentsToOverride((prev) => {
      if (prev.includes(rollNo)) {
        return prev.filter((roll) => roll !== rollNo);
      } else {
        return [...prev, rollNo];
      }
    });
  };
  const handleSkipAll = () => {
    const allRollNumbers = students.map((student) => student.roll_no);
    setStudentsToSkip(allRollNumbers);
    setIsModalOpen(false);
  };
  const uploadExcelFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("excel_file", file);
      const response = await axios.post(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/process-omr-excel/?assessment_id=${selectedTest.assessment_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const urlList = response.data.url_list;
      setUrlList(urlList);
      setExcelUploaded(true);
      return urlList;
    } catch (error) {
      console.error("Error uploading Excel file: ", error);
    }
  };
  const uploadFileToS3 = async (file, presignedUrl) => {
    try {
      const result = await axios.put(presignedUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      console.log(result);
    } catch (error) {
      console.error("Error uploading file: ", error);
    }
  };
  const handleExcelFileChange = async (event) => {
    const excelFile = event.target.files[0];
    if (excelFile) {
      await uploadExcelFile(excelFile);
    }
  };

  // const handleFolderChange = async () => {
  //   try {
  //     const dirHandle = await window.showDirectoryPicker();
  //     const files = [];
  //     for await (const entry of dirHandle.values()) {
  //       if (entry.kind === "file" && entry.name.match(/\.(jpg|jpeg|png)$/i)) {
  //         const file = await entry.getFile();
  //         files.push(file);
  //       }
  //     }
  //     setFiles(files);
  //     const matchedFiles = files.filter((file) =>
  //       urlList.some((urlObj) => urlObj.file_path === file.name)
  //     );
  //     setMatchedFiles(matchedFiles);
  //     setExcelUploaded(true); // Set excelUploaded to true here
  //   } catch (error) {
  //     console.error("Error selecting folder: ", error);
  //   }
  // };


  const handleFolderChange = async () => {
    try {
      const dirHandle = await window.showDirectoryPicker();
      const files = [];
      for await (const entry of dirHandle.values()) {
        if (entry.kind === "file" && entry.name.match(/\.(jpg|jpeg|png)$/i)) {
          const file = await entry.getFile();
          files.push(file);
        }
      }
      setFiles(files);
      const matchedFiles = files.filter((file) =>
        urlList.some((urlObj) => urlObj.file_path.includes(file.name))
      );
      setMatchedFiles(matchedFiles);
      setExcelUploaded(true);

      // Show message box after images are chosen
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider2">
            <div className="loader-tc"></div>
            <div className="row-cs-uni" style={{ width: "100%", padding: "4px 8px" }}>
              <div className="col-cs-uni">
                <span>Images chosen , please proceed with clicking on save.</span>
              </div>
              <div className="col-cs-uni" style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", position: "relative", top: "-5px" }}>
                <button
                  style={{ marginRight: "8px" }}
                  onClick={() => {
                    setMessageBox(null);
                    setActiveImg(null);
                    setIsMessageBoxVisible(false);
                  }}
                  className="testreportcard-create-btn"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      );
      setActiveImg(SucessImg);
      setIsMessageBoxVisible(true);

    } catch (error) {
      console.error("Error selecting folder: ", error);

      // Optional: Show error message if folder selection fails
      if (error.name !== 'AbortError') { // Don't show error if user just cancelled
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Error selecting folder. Please try again.</span>
              <div style={{ marginTop: "15px", textAlign: "center" }}>
                <button
                  onClick={() => {
                    setMessageBox(null);
                    setActiveImg(null);
                    setIsMessageBoxVisible(false);
                  }}
                  className="Excel-UOD-button-3"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }
    }
  };

  const handleUploadClick = async () => {
    try {
      uploadImages(files);
    } catch (error) {
      console.error(error);
    }
  };
  const uploadImages = (files) => {
    for (const file of files) {
      const matchingUrl = urlList.find((urlObj) =>
        urlObj.file_path.includes(file.name)
      );
      if (matchingUrl) {
        uploadFileToS3(file, matchingUrl.url);
      }
    }
  };
  useEffect(() => {
    if (isModalOpen) {
    } else {
      setShowAnimation(false);
    }
  }, [isModalOpen]);

  const downloadErrors = () => {
    const element = document.createElement("a");
    const file = new Blob([errors.join("\n")], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "errors.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  // Updated useEffect to use the new test schedule API
  // Updated useEffect to use the new test schedule API with Authorization token
  useEffect(() => {
    const fetchTestSchedules = async () => {
      if (courseOpted && searchKey) {
        try {
          const token = localStorage.getItem("other");
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-test-schedule-details-by-course-id/?course_id=${courseOpted}&client_branch_id=${clientBranchId}&search_key=${searchKey}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          const data = await response.json();
          if (data.status === 200) {
            setTestSchedules(data.data); // Updated to use new state
            setShowDropdown(true);
          }
        } catch (error) {
          console.error("Error fetching test schedules:", error);
        }
      } else {
        setShowDropdown(false);
      }
    };
    fetchTestSchedules();
  }, [courseOpted, searchKey, clientBranchId]);

  // New function to clear selected test
  const handleClearSelection = () => {
    setSelectedTest(null);
    setSearchKey("");
    setShowDropdown(false);
  };
  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up ">
          <p className="title-cb ">Upload OMR </p>

          <div className="mb-2-UP grey-color-font">
            <button
              className="cr-cancel-btn me-cs4"
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>

            <button
              className="cr-create-btn"
              onClick={() => {
                handleUploadClick();
                handleSave();
              }}
            >
              SAVE
            </button>
          </div>
        </div>

        <hr className="hr-otc" />
      </div>
      {successMessageVisible && (
        <SuccessMessage
          message="Files uploading . . ."
          countdownTime={10}
          onCountdownComplete={() => window.location.reload()}
        />
      )}

      <div
        className="container-cs-fluid ms-cs3 mt-cs3"
        style={{ width: "98%" }}
      >
        <div
          className="card-border-CR"
          style={{ backgroundColor: `${Colors.color10}` }}
        >
          <div
            className="transparent-margin-left-UP transparent-margin-all"
            style={{
              backgroundColor: `${Colors.color9}`,
              fontWeight: "600",
              fontSize: "14px",
              color: `${Colors.color1}`,
            }}
          >
            UPLOAD OMR DATA
          </div>

          {/* TEMPORARY TEST BUTTONS - Remove after testing */}
          {/* <div style={{ padding: "20px", display: "flex", gap: "10px", backgroundColor: "#f0f0f0" }}>
            <button
              onClick={() => testMessageBoxes(200)}
              style={{ padding: "10px 20px", backgroundColor: "#4CAF50", color: "white", border: "none", cursor: "pointer" }}
            >
              Test Status 200
            </button>
            <button
              onClick={() => testMessageBoxes(207)}
              style={{ padding: "10px 20px", backgroundColor: "#FF9800", color: "white", border: "none", cursor: "pointer" }}
            >
              Test Status 207
            </button>
            <button
              onClick={() => testMessageBoxes(500)}
              style={{ padding: "10px 20px", backgroundColor: "#F44336", color: "white", border: "none", cursor: "pointer" }}
            >
              Test Status 500
            </button>
          </div> */}

          <div style={{ padding: "15px" }}>
            {/* Updated 3-column layout with InputComponents */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              {/* Column 1 - Course Dropdown + Test Name */}
              <div
                style={{
                  flex: "1",
                  minWidth: "250px",
                  color: `${Colors.color1}`,
                }}
              >
                <DropDown
                  label="Course"
                  style={{ width: "100%" }}
                  setSelected={setCourseOpted}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={true}
                />

                <div style={{ marginTop: "10px" }}>
                  <InputComponent
                    label="Test Window Start"
                    style={{ width: "100%" }}
                    value={selectedTest?.test_window_start || ""}
                    isRequired={false}
                    disable={true}
                  />
                </div>

                {/* <InputComponent
                  label="Status"
                  style={{ width: "100%" }}
                  value={selectedTest?.status_name || ""}
                  isRequired={false}
                  disable={true}
                /> */}
              </div>

              {/* Column 2 - Search Test + Course Name */}
              {/* Column 2 - Search Test + Course Name */}
              <div style={{ flex: "1", minWidth: "250px" }}>
                <div
                  className="search-ts"
                  style={{ color: `${Colors.color1}`, marginBottom: "6px" }}
                >
                  <p className="color424342">Search Test</p>
                  <div ref={dropdownRef} style={{ position: "relative" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid ${Colors.color3}`,
                        width: "100%",
                        marginTop: "6px",
                        height: "32px",
                        backgroundColor: `${Colors.color14}`,
                        position: "relative",
                      }}
                    >
                      <input
                        style={{
                          height: "30px",
                          width: "100%",
                          padding: "5px",
                          paddingRight: "35px", // Fixed padding for yellow icon
                          border: "none",
                          color: `${Colors.color3}`,
                          backgroundColor: `${Colors.color14}`,
                          cursor: selectedTest ? "default" : "text",
                        }}
                        type="text"
                        placeholder={
                          selectedTest ? "" : "Search test schedules..."
                        }
                        value={searchKey}
                        onChange={handleSearchChange}
                        readOnly={selectedTest ? true : false}
                      />

                      {/* Cross button - shows when test is selected, positioned left of yellow icon */}
                      {selectedTest && (
                        <button
                          onClick={handleClearSelection}
                          style={{
                            position: "absolute",
                            right: "30px", // Position it left of the yellow icon
                            background: "transparent",
                            border: "none",
                            fontSize: "18px",
                            color: `${Colors.color1}`,
                            cursor: "pointer",
                            padding: "0",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1,
                          }}
                        >
                          ×
                        </button>
                      )}

                      {/* Yellow search icon - always at the very right */}
                      <img
                        style={{
                          height: "25px",
                          width: "25px",
                          padding: "1px",
                          position: "absolute",
                          right: "4px", // Always at the very right
                        }}
                        src={searchyellow}
                        alt="searchyellow"
                      />
                    </div>

                    {showDropdown && !selectedTest && (
                      <div className="dropdown-UOD-2" style={{ width: "100%" }}>
                        {testSchedules.map((testSchedule, index) => (
                          <div
                            key={index}
                            onClick={() => handleTestSelect(testSchedule)}
                            style={{ width: "100%", cursor: "pointer" }}
                          >
                            <p style={{ padding: "10px" }}>
                              {testSchedule.test_name}
                              <span
                                style={{
                                  color: "#666",
                                  fontSize: "12px",
                                  marginLeft: "8px",
                                }}
                              >
                                / {testSchedule.status_name}
                              </span>
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div style={{ marginTop: "10px" }}>
                  <InputComponent
                    label="Test Window End"
                    style={{ width: "100%" }}
                    value={selectedTest?.test_window_end || ""}
                    isRequired={false}
                    disable={true}
                  />
                </div>
                <br />
              </div>

              {/* Column 3 - Test Details */}
              <div style={{ flex: "1", minWidth: "250px" }}>
                {/* <InputComponent
                  label="Test Name"
                  style={{ width: "100%" }}
                  value={selectedTest?.test_name || ""}
                  isRequired={false}
                  disable={true}
                /> */}

                <InputComponent
                  label="Subject"
                  style={{ width: "100%" }}
                  value={selectedTest?.subject_name || ""}
                  isRequired={false}
                  disable={true}
                />

                <div style={{ marginTop: "10px" }}>
                  <InputComponent
                    label="Duration (mins)"
                    style={{ width: "100%" }}
                    value={selectedTest?.duration_mins || ""}
                    isRequired={false}
                    disable={true}
                  />
                </div>
              </div>
            </div>

            {/* Second row for additional test details */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "flex-start",
                width: "100%",
                marginTop: "20px",
              }}
            >
              {/* Subject field spanning across columns */}
              <div style={{ flex: "2", minWidth: "500px" }}>
                {/* <InputComponent
                  label="Subject"
                  style={{ width: "100%" }}
                  value={selectedTest?.subject_name || ""}
                  isRequired={false}
                  disable={true}
                /> */}
              </div>

              {/* Empty space to maintain layout */}
              <div style={{ flex: "1", minWidth: "250px" }}>
                {/* Reserved for future use */}
              </div>
            </div>
          </div>

          <div>
            <div
              className="UploadDivWhite"
              style={{
                marginLeft: "15px",
                // marginTop: "10px",
                marginBottom: "10px",
                border: `1px dotted ${Colors.color3}`,
                height: "200px",
                width: "98%",
                backgroundColor: showAnimation ? "white" : "white",
                opacity: showAnimation ? 1 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              {!showAnimation && (
                <>
                  {" "}
                  <div
                    className="for-browse-and-upload"
                    style={{ width: "100%", display: "flex" }}
                  >
                    <div style={{ width: "33.5%" }}>
                      {" "}
                      <p
                        onClick={handleDivClick}
                        onChange={handleExcelFileChange}
                        style={{ marginRight: "10%" }}
                      >
                        Browse the excel file generated by OMR software
                      </p>
                      <br />
                      <br />
                      <p onClick={handleFolderChange}>
                        Browse the folder that contains OMR images for the excel
                        file
                      </p>
                    </div>
                    <div
                      style={{
                        width: "39%",
                        height: "auto",
                      }}
                    >
                      <button
                        style={{ width: "200px" }}
                        onClick={handleDivClick}
                        onChange={handleExcelFileChange}
                        className="Excel-UOD-button-3"
                      >
                        Browse
                      </button>

                      <br />
                      <br />

                      <button
                        style={{ width: "200px" }}
                        className="Excel-UOD-button-3"
                        onClick={handleFolderChange}
                      >
                        Browse
                      </button>
                    </div>
                    {/* <div></div> */}
                  </div>
                  {/* <div className="Both-buttons-UOD">
                    <div
                      onClick={handleDivClick}
                      onChange={handleExcelFileChange}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <p style={{ marginRight: "10%" }}>
                        Browse the excel file generated by OMR software
                      </p>
                      <button className="Excel-UOD-button">Browse</button>
                    </div>

                    <div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ marginRight: "4.1%" }}>
                          Browse the folder that contains OMR images for the
                          excel file
                        </p>
                        <button
                          className="Excel-UOD-button-2"
                          onClick={handleFolderChange}
                          style={{ marginLeft: "15px" }}
                        >
                          Browse
                        </button>
                      </div>
                    </div>
                  </div> */}
                </>
              )}

              <input
                type="file"
                ref={fileInput}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              {showAnimation && (
                <div className="loader">
                  <div className="inner one"></div>

                  <div className="inner two"></div>

                  <div className="inner three"></div>
                </div>
              )}
            </div>
            {/* <div>
              <div className="SiderNotification">
                {showModalSider && (
                  <div className={`modalSider ${animationSider}`}>
                    <h2>LOADING</h2>
                    <p>Please wait processing data ... </p>
                  </div>
                )}
              </div>
            </div> */}
            <div>
              {isModalOpen && (
                <CustomModal
                  students={students}
                  handleSkip={handleSkipChange}
                  handleSkipAll={handleSkipAll}
                  handleOverride={handleOverrideChange}
                  closeModal={() => setIsModalOpen(false)}
                />
              )}
            </div>

            <div>
              {showModal && (
                <div className="modal-overlay-UOD">
                  <div className="modal-container-UOD">
                    <div>
                      {" "}
                      <span
                        className="none-x-button-UOD"
                        onClick={handleCloseModal}
                        style={{}}
                      >
                        {" "}
                        <button
                          style={{
                            border: "none",

                            background: "transparent",

                            fontSize: "18px",
                          }}
                        >
                          ×
                        </button>
                      </span>
                    </div>

                    <div className="modal-header-UOD">
                      <h2>OMR Uploaded Successfully</h2>
                    </div>

                    <div className="modal-body-UOD">
                      <p className="text-p-UOD">
                        Please see details below for the rows that were not
                        uploaded:
                      </p>

                      <table className="errors-table-UOD">
                        <tbody>
                          {errors.map((error, index) => (
                            <tr key={index}>
                              <td className="errors-errors-UOD">{error}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="modal-footer-UOD">
                      <button onClick={downloadErrors}>Download Errors</button>{" "}
                      <button onClick={handleCloseModal}>Close</button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={{ width: "100%" }}>
              {excelUploaded && (
                <>
                  <div className="file-row-div-UOD">
                    <p className="basic-color-info-UOD">
                      OMR images are being processed please click on Save to
                      continue :
                    </p>
                    <div className="file-row">
                      {matchedFiles.map((file, index) => (
                        <div key={index} style={{ whiteSpace: "normal" }}>
                          {file.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div style={{ padding: "15px" }}>
              {errors.length > 0 && (
                <div>
                  <p className="color424342" style={{ paddingTop: "5px" }}>
                    Warning:
                  </p>

                  <ul style={{ paddingTop: "5px" }}>
                    {errors.map((error, index) => (
                      <li
                        style={{ paddingTop: "5px", color: "darkred" }}
                        key={index}
                      >
                        {error}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadOmrV2;
